import { createSlice } from '@reduxjs/toolkit'

export const contentSlice = createSlice({
  name: 'content',
  initialState: {
    id: null,
    hero: null,
    title: null,
    brand: null,
    description: null,
    buyOnline: null,
    contentTermId: null,
    contentTerms: '',
    endDate: null,
    buyInStore: null,
    content: null,
    showBuyInStore: false,
    toggleTerms: false,
    type: null,
    showContent: false,
    applePass: false,
    showDownload: false,
    androidPass: true,
    jwt: '',
    terms: '',
    clickThroughBtnOne: '',
    clickThroughBtnTwo: '',
    buyNowText: 'Buy Now',
    buyInStoreText: 'Buy In-Store',
  },
  reducers: {
    setContentItem: (state, action) => {
      state.id = action.payload.id;
      state.hero = action.payload.hero;
      state.title = action.payload.title;
      state.brand = action.payload.brand;
      state.description = action.payload.description;
      state.buyOnline = action.payload.buyOnline;
      state.contentTermId = action.payload.contentTermId;
      state.contentTerms = action.payload.contentTerms;
      state.endDate = action.payload.endDate;
      state.buyInStore = action.payload.buyInStore;
      state.showBuyInStore = action.payload.showBuyInStore;
      state.toggleTerms = action.payload.toggleTerms;
      state.type = action.payload.type;
      state.showContent = action.payload.showContent;
      state.content = action.payload.content;
      state.applePass = action.payload.applePass;
      state.showDownload = action.payload.showDownload;
      state.buyNowText = action.payload.buyNowText;
      state.buyInStoreText = action.payload.buyInStoreText;
      state.clickThroughBtnOne = action.payload.clickThroughBtnOne;
      state.clickThroughBtnTwo = action.payload.clickThroughBtnTwo;
    },
    setAndroidPassDetails: (state, action)=> {
      state.androidPass = action.payload.androidPass;
      state.jwt = action.payload.jwt;
    },
    setTerms: (state, action) => {
      state.terms = action.payload;
    },
    setContentResponse: (state, action) => {
      state.content = action.payload
    }
  }
})

export const { setContentItem, setAndroidPassDetails, setTerms, setContentResponse } = contentSlice.actions

export default contentSlice.reducer